import React, { Component } from 'react'

const scale = [
  { item: 1 },
  { item: 2 },
  { item: 3 },
  { item: 4 },
  { item: 5 },
  { item: 6 },
]

class Likert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      load: 0,
    }
  }

  render() {
    return (
      <div className={`likert`}>
        {scale.map((itm, ind) => {
          return <div key={ind}>{itm.item}</div>
        })}
      </div>
    )
  }
}
export default Likert
